import React from 'react';
import PropTypes from 'prop-types';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../styles';

const styles = css`
  padding: 60px 0 0 0;
  @media(min-width: 768px) {
    padding: 100px 0 0 0;
  }
  .InsideHeaderImageWrapper {
    background-size: cover;
    background-position: center center;
    width: 100%;
    position: relative;
    padding: 0 30px;
    height: 260px;
    @media(min-width: 768px) {
      height: 320px;
      padding: 0 50px;
    }
  }
  .InsideHeaderH1 {
    display: flex;
    font-size: 28px;
    letter-spacing: 0;
    color: ${colors.white};
    font-weight: 400;
    z-index: 2;
    display: none;
    text-shadow: 0 1px 2px rgba(0,0,0,.7), 0 2px 10px rgba(0,0,0,.4);
    @media(min-width: 768px) {
      font-size: 46px;
      letter-spacing: -0.8px;
      width: 75%;
      text-align: center;
    }
    @media(min-width: 1490px) {
      font-size: 52px;
    }
  }
  .InsideHeaderContainer {
    height: 100%;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .HeaderOverlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(24,22,17,.5);
    z-index: 1;
  }

  .InsideHeaderP {
    font-size: 16px;
    color: ${colors.white};
    font-weight: 400;
    z-index: 2;
    text-align: center;
    display: none;
    @media(min-width: 768px) {
      font-size: 26px;
    }
    @media(min-width: 1490px) {
      font-size: 45px;
    }
  }

  .InsideHeaderImg {
    z-index: 1;
    width: 80%;
    max-width: 460px;
    display: none;
  }

  .InsideHeaderH1Small {
    font-size: 26px;

  }

  .TitleDelay {
    display: flex;
    justify-content: center;
    text-align: center;
  }
`;


class InsideHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };
  }
  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({
        show: true,
      });
    }, 700);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    const { h1, p, background, image } = this.props;
    const { show } = this.state;
    const mediaStyle = {};
    if (background) {
      mediaStyle.backgroundImage = `url('${buildThumbnailUrl(background, { width: 2000, height: 2000 })}')`;
    }
    return (
      <div className={styles}>
        <div className="InsideHeaderImageWrapper" style={mediaStyle}>
          <div className="InsideHeaderContainer">
            <div className="HeaderOverlay" />
            {
              image &&
              <img src={image} alt="DesignStudio Logo" className={`InsideHeaderImg ${show ? 'animated fadeInLeft TitleDelay' : ''}`} />
            }
            {
              h1 &&
              <h1
                className={`InsideHeaderH1 ${image ? 'InsideHeaderH1Small' : ''} ${image && show ? 'animated fadeInRight TitleDelay' : ''} ${!image && show ? 'animated fadeInLeft TitleDelay' : ''}`}
              >
                {h1}
              </h1>
            }
            {
              p &&
              <p className={`InsideHeaderP ${show ? 'animated fadeInRight TitleDelay' : ''}`}>{p}</p>
            }
          </div>
        </div>
      </div>
    );
  }
}

InsideHeader.propTypes = {
  h1: PropTypes.node,
  p: PropTypes.node,
  background: PropTypes.string,
  image: PropTypes.string,
};

InsideHeader.defaultProps = {
  h1: undefined,
  p: undefined,
  background: undefined,
  image: undefined,
};


export default InsideHeader;



// WEBPACK FOOTER //
// ./src/components/InsideHeader.js